// extracted by mini-css-extract-plugin
export default {"root":"Navbar_root__-ZSY8","menuWrapper":"Navbar_menuWrapper__xNk0d","titleWrapper":"Navbar_titleWrapper__EY7eW","accountWrapper":"Navbar_accountWrapper__3pDcW"};